import { useEffect, useState } from "react";

import {
  useWorkspace,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";
import { readDarkThemeSwitcherOverride } from "src/util/darkThemeSwitcherFlag";

/**
 * Workspace-scoped flag for showing the user-menu dark theme switcher.
 *
 * Reads `workspace.config.featureFlags.enableDarkThemeSwitcher`, falling back
 * to a per-workspace localStorage override while teamform-api doesn't yet
 * persist the key (see `src/util/darkThemeSwitcherFlag.js`).
 */
export const useEnableDarkThemeSwitcherFlag = () => {
  const workspace = useWorkspace();
  const workspaceFeatureFlags = useWorkspaceFeatureFlags();
  const workspaceId = workspace?.id;

  const [override, setOverride] = useState(() =>
    readDarkThemeSwitcherOverride(workspaceId)
  );

  useEffect(() => {
    setOverride(readDarkThemeSwitcherOverride(workspaceId));
  }, [workspaceId]);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const onStorage = (event) => {
      if (
        !event.key ||
        event.key.startsWith("teamform.enableDarkThemeSwitcher")
      ) {
        setOverride(readDarkThemeSwitcherOverride(workspaceId));
      }
    };

    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [workspaceId]);

  const fromConfig = workspaceFeatureFlags?.enableDarkThemeSwitcher;
  if (override !== null) {
    return override;
  }
  return fromConfig ?? false;
};
